import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import cx from 'clsx';
import { useTheme } from '../../ThemeProvider';
import classes from './Tabs.styles.less';
export default function Tabs({ className, data, active, onTabChange }) {
    const [theme] = useTheme();
    const tabs = data.map((tab) => (_jsx("button", { type: "button", onClick: () => onTabChange(tab.value), className: cx(classes.control, {
            [classes.active]: active === tab.value,
        }), children: tab.label }, tab.value)));
    return _jsx("div", { className: cx(classes.tabs, classes[theme], className), children: tabs });
}
